<template>
 
    
    <div class="contenedor-flex">
      <Loading :active.sync="Loading"></Loading>
      <div class="container-cabecera">
        <label class="h2-rciempaques">RCI Empaques</label>
        <router-link to="/home/datosrci"> <a class="btn btn-ofimpresa"><i class="fa fa-chevron-left" aria-hidden="true"></i>
Regresar a Datos RCI</a> </router-link>
      </div>
      <div class="container-orden"> 
        <label class="orden-l">Orden de fabricación:</label>
        <input type="text" class="buscar orden-i" id="ordendefabricacion" v-model="valor" @keyup.enter="buscar">
        <label class="fechav-l">Fecha de vencimiento:</label>
        <input class="fechav-i" v-model="datosphp['0']['DueDate']"  readonly>
        <label class="codigocliente-l">Codigo de cliente:</label>
        <input class="codigocliente-i" v-model="datosphp['0']['CardCode']"  readonly>
        <label class="ordencompra-l">Orden de compra:</label>
        <input class="ordencompra-i" v-model="datosphp['0']['NumAtCard']"  readonly>
        <label class="fecha-l">Fecha:</label>
        <input class="fecha-i" v-model="datosphp['0']['PostDate']" readonly>
        <label class="statusof-l">Status OF y MP:</label>
        <input class="statusof-i" v-model="datosphp['0']['Status O.F.']"  readonly>
        <div class="pedido-l">Pedido:</div>
        <input class="pedido-i" v-model="datosphp['0']['OriginNum']"  readonly>  
        <label class="cliente-l">Cliente:</label>
        <input class="cliente-i" v-model="datosphp['0']['CardName']" readonly>
      </div>
      <div class="container-detalle">
        <h6 class="detalle-articulo">Detalle del artículo</h6>
        <div class="planificadal ml-2">Planificada</div>
        <input  class="planificadai"  readonly v-model="planificada" >
        <div class="numero-articulol">Número de articulo </div>
        <input class="numero-articuloi" readonly v-model="datosphp['0']['ASCODPT']"> 
        <div class="entregado-ptl ml-2">Entregado a PT</div>
        <input class="entregado-pti" readonly v-model="entregado_pt">
        <div class="numero-articulo-sn-l">Número articulo SN</div>
        <input class="numero-articulo-sn-i "  readonly v-model="datosphp['0']['NoArticuloSN']">
        <div class="codigo-almacen-l">Codigo de almacén</div>
        <input class="codigo-almacen-i" readonly v-model="datosphp['0']['Warehouse']"> 
        <div class="rechazada-l ml-2">Rechazada</div>
        <input class="rechazada-i" readonly v-model="rechazado">
        <div class="descripcion-l">Descripción del articulo</div>
        <input v-model="datosphp['0']['NOMBREPT'] " readonly class="descripcion-i">
        <div class="abierta-l ml-2">Abierta</div>
        <input class="abierta-i" readonly v-model="abierto">
      </div>
  
      <div class="contenedor">
        <div class="">
          <div class="container-table">
              <div class="table-header-articulo">{{ fields[0].label }} </div>
              <div class="table-header-descripcion">{{ fields[1].label }} </div>
              <div class="table-header-um">{{ fields[2].label }}</div>
              <div class="table-header-planificada">{{ fields[3].label }}</div>
              <div class="table-header-salida">{{ fields[4].label }}</div>
              <div class="table-header-almacen">{{ fields[5].label }}</div> 
          </div>
        </div>
        <div v-for="(row, idx1) in data" class="container-table">
            <div class="table-item-articulo"> {{row.CODMP2}} </div>
            <div class="table-item-descripcion"> {{row.NOMMP2}} </div>
            <div class="table-item-um"> {{row.UNIDADMP2}} </div>
            <div class="table-item-planificada"> {{row.PANIFMP2}} </div>
            <div class="table-item-salida"> {{row.COMPLETAMP2}} </div>
            <div class="table-item-almacen"> {{row.ALMMP2}}</div>
        </div>
      </div> <!-- contenedor -->
      <div class="container-otros">
        <div class="tinta1-l">Tinta 1:</div>
        <input  class="tinta1-i"  readonly v-model="datosphp['0']['U_Tinta1']" >
        <div class="suaje-l">Suaje:</div>
        <input  class="suaje-i"  readonly v-model="datosphp['0']['U_Suaje']" >
        <div class="lote-l">Lote:</div>
        <input  class="lote-i"  readonly v-model="datosphp['0']['U_Lote']" >
        <div class="tinta2-l">Tinta 2:</div>
        <input  class="tinta2-i"  readonly v-model="datosphp['0']['U_Tinta2']" >
        <div class="tinta3-l">Tinta 3:</div>
        <input  class="tinta3-i"  readonly v-model="datosphp['0']['U_Tinta3']" >
        <div class="tinta4-l">Tinta 4:</div>
        <input  class="tinta4-i"  readonly v-model="datosphp['0']['U_Tinta4']" >
        <div class="tinta5-l">Tinta 5:</div>
        <input  class="tinta5-i"  readonly v-model="datosphp['0']['U_Tinta5']" >
        <div class="tinta6-l">Tinta 6:</div>
        <input  class="tinta6-i"  readonly v-model="datosphp['0']['U_Tinta6']" >
        <div class="reverso-l">Reverso:</div>
        <input  class="reverso-i"  readonly v-model="datosphp['0']['u_Reverso']" >
        <div class="barniz-l">Barniz:</div>
        <input  class="barniz-i"  readonly v-model="datosphp['0']['U_Barniz']" >
        <div class="procesos-l">Procesos:</div>
        <input  class="procesos-i"  readonly v-model="datosphp['0']['U_Procesos']" >
        <div class="planilla-l">Planilla:</div>
        <input  class="planilla-i"  readonly v-model="datosphp['0']['U_Planilla']" >
        <div class="corte-l">Corte:</div>
        <input  class="corte-i"  readonly v-model="datosphp['0']['U_Corte']" >
        <div class="excedente-l">Excedente:</div>
        <input  class="excedente-i"  readonly v-model="excedente" >
        <div class="pliegos-l">Pliegos a Imprimir:</div>
        <input  class="pliegos-i"  readonly v-model="datosphp['0']['U_Pliegos_a_imprimir']" >
        <div class="comentarios-l">Comentarios:</div>
        <div  class="comentarios-i"   >{{ datosphp['0']['Comentarios'] }} </div>
        <div class="corrugado-l">Corrugado:</div>
        <input  class="corrugado-i"  readonly v-model="datosphp['0']['NUMCorrugado']" >
        <div class="unidadcarga-l">Unidad de Carga:</div>
        <input  class="unidadcarga-i"  readonly v-model="unidad_de_carga" >
        <div class="pesoarticulo-l"><span class="mr-1">Peso Articulo</span><strong>Gr</strong>:</div>
        <input  class="pesoarticulo-i"  readonly v-model="datosphp['0']['PESO']" >
        <div class="peso-corrugado-l"><span class="mr-1">Peso/Corrugado</span><strong>KG</strong>:</div>
        <div  class="peso-corrugado-i" >{{ (datosphp['0']['PESO'] * datosphp['0']['U_Unidad_Carga'] / 1000).toFixed(2) }}</div>
      </div>
    </div> <!-- contenedor-flex -->  
      

</template>

<script>
    import {mapActions, mapState, mapGetters} from 'vuex'
    import Loading from 'vue-loading-overlay'
    import 'vue-loading-overlay/dist/vue-loading.css'
    import moment from 'moment' //librearia de formatos de fecha
    import customMixin from '@/mixins/customMixin'
    import _ from 'lodash'
  
    
    

    export default {
        name:'ofdatosrci',
        mixins : [customMixin],
        components:{
            Loading
        },
        data:function(){
          return{
                data:[],
                valor:'',
                fields: [
                        { field: 'CODMP2', label:"Num de articulo"},
                        { field: 'NOMMP2', label:"Descripción" },
                        { field: 'PANIFMP2', label:"UM" },
                        { field: 'COMPLETAMP2', label:"Ctd. Planificada" },
                        { field: 'UNIDADMP2', label:"Ctd. Salida" },
                        { field: 'ALMMP2', label:"Cod. Almacen" },    
                ],
                isOK: false, // usado para descargar excel
                isWeb: false, // para la tabla generica
                vtkey:0,
                abierto:0,
                planificada:0,
                entregado_pt:0,
                rechazado:0,
                excedente:0,
                unidad_de_carga:0,
          }
        },
        created(){
         this._fetchPermisos(this.rol_id).then(() => {  
                
                this._fetchDatosRCI('0')      
              })//_fetchPermisos
        },
        
        mounted(){
           //
        },
        updated(){
          //
        },
        watch:{
	      	//
	      },
         computed:{
            ...mapState('ofdatosrci',['datosphp']),
            ...mapState(['Loading']),
            ...mapState('login',['rol_id']),
            ...mapState('permiso',['permiso']),  
            ...mapState(['windowWidth']),//llamamos al estado.
            sortOptions() {
             // Create an options list from our fields
             return this.fields
               .filter(f => f.sortable)
               .map(f => {
                 return { text: f.label, value: f.key }
               })
            },
            
        }, 
        methods:{
            ...mapActions({
                _fetchDatosRCI: 'ofdatosrci/fetchOfDatosRCI',
                _fetchPermisos: 'permiso/fetchPermisosUsuarios',
                
            }),
            buscar(){

              this._fetchDatosRCI(this.valor).then(() => { 
                   let that = this
                   this.data = []
                   this.planificada = this.thousands_separators(Number(this.datosphp['0']['PLANIFPT']))
                   this.entregado_pt = this.thousands_separators(Number(this.datosphp['0']['CmpltQty']))
                   this.rechazado = this.thousands_separators(Number(this.datosphp['0']['RjctQty']))
                   this.excedente = this.thousands_separators(Number(this.datosphp['0']['U_EficienciaR7']))
                   this.unidad_de_carga = this.thousands_separators(Number(this.datosphp['0']['U_Unidad_Carga']))
                   this.abierto = this.thousands_separators(Number(this.datosphp['0']['PLANIFPT']) - Number(this.datosphp['0']['CmpltQty']) - Number(this.datosphp['0']['RjctQty']))
                   _.forEach(this.datosphp, function(value,key){
                     let arr = []
                     let obj0  
                     let obj1 
                     let obj2 
                     let obj3 
                     let obj4 
                     let obj5
                    _.forEach(value, function(value2,key2){
                      if(key2 == "CODMP2"){
                        obj0 = {"CODMP2":value2}
                      }
                      if(key2 == "NOMMP2"){
                        obj1 = {"NOMMP2":value2}
                      }
                      if(key2 == "PANIFMP2"){
                        obj2 = {"PANIFMP2":that.thousands_separators(value2)}
                      }
                      if(key2 == "COMPLETAMP2"){
                        obj3 = {"COMPLETAMP2":that.thousands_separators(value2)}
                      }//ALMMP
                      if(key2 == "UNIDADMP2"){
                        obj4 ={"UNIDADMP2":value2} 
                      }
                      if(key2 == "ALMMP2"){
                        obj5 ={"ALMMP2":value2}
                      }
                    })
                    that.data.push(Object.assign({},obj0,obj1,obj2,obj3,obj4,obj5))                     
                  })    
              })
             
            },
            
        }, //end methods
        
    }
</script>

<style lang="scss">
  .contenedor-flex{
  display:flex;
  font-size: 0.8em;
  flex-direction: column;
  width: 98vw;
  padding-left:1em;
  padding-right:1em;
  margin-left:0;
  margin-right:0;
  padding-bottom:2em;
  padding-top:1em;
  
  }
  .buscar{
    background-color:beige;
  }
  .container-orden{
  display:grid;
  width: 100%;
  grid-template-columns: repeat(8, 1fr);
  grid-template-rows: repeat(4, 1fr);
  grid-template-areas: 
    "a1 a2 a3 a4 a5 a6 a7 a7"
    "b1 b2 b3 b4 b5 b6 b7 b8"
    "c1 c2 c3 c4 c5 c6 c6 c6"
    "d1 d2 d3 d4 d5 d6 d7 d8"
  ;
  .orden-l{
    display:flex;
    justify-content: flex-end;
    margin-right:0.5em;
    grid-area: a1;
  }
  .orden-i{
    grid-area: a2;
  }
  .fechav-l{
    display:flex;
    justify-content: flex-end;
    margin-right:0.5em;
    grid-area: b1;
  }
  .fechav-i{
    grid-area: b2;
  }
  .codigocliente-l{
    display:flex;
    justify-content: flex-end;
    margin-right:0.5em;
    grid-area:c1;
  }
  .codigocliente-i{
    grid-area: c2;
  }
  .ordencompra-l{
    display:flex;
    justify-content: flex-end;
    margin-right:0.5em;
    grid-area: d1;
  }
  .ordencompra-i{
    grid-area: d2;
  }
  .fecha-l{
    display:flex;
    justify-content: flex-end;
    margin-right:0.5em;
    grid-area:a6;
  }
  .fecha-i{
    display:flex;
    justify-content: center;
    align-items: center;
    /*text-align: center;*/
    grid-area:a7;
  }
  .statusof-l{
    display:flex;
    justify-content: flex-end;
    margin-right:0.5em;
    grid-area:b5;
  }
  .statusof-i{
    grid-area:b6;
  }
  .pedido-l{
    display:flex;
    justify-content: flex-end;
    margin-right:0.5em;
    grid-area:b7
  }
  .pedido-i{
    grid-area:b8;
  }
  .cliente-l{
    display:flex;
    justify-content: flex-end;
    margin-right:0.5em;
    grid-area:c5;
  }
  .cliente-i{
    grid-area:c6;
  }
  }
  @media screen and (max-width: 576px){
    .container-orden{
      grid-template-columns: repeat(2, 1fr); 
      grid-template-areas: 
      "a1 a2"
      "b1 b2"
      "c1 c2"
      "d1 d2"
      "a6 a7"
      "b5 b6"
      "b7 b8"
      "c5 c6"
      ;
    }
  }
  input{
    height:25px;
  }
  .contenedor{
    display: grid;
    width: 100%; 
    overflow-x: scroll;
  }

  .container-detalle{
    display:grid;
    width: 100%;

    grid-template-columns: repeat(8,1fr);
    grid-template-rows: repeat(4, 1fr) ;
    grid-template-areas: 
     "a1 a1 a1 a1 a1 a1 a2 a3"
     "b1 b2 b3 b3 b3 b3 b4 b5"
     "c1 c2 c3 c4 c5 c6 c7 c8"
     "d1 d2 d2 d2 d2 d2 d3 d4"
    ;
    .detalle-articulo{
      grid-area: a1;
    }
    .planificadal{
      display:flex;
      justify-content: flex-end;
      margin-right:0.5em;
      grid-area: a2;
    }
    .planificadai{
     grid-area: a3;
    }
    .numero-articulol{
      display:flex;
      justify-content: flex-end;
      margin-right:0.5em;
      grid-area: b1;
    }
    .numero-articuloi{
      grid-area: b2;
    }
    .entregado-ptl{
      display:flex;
      justify-content: flex-end;
      margin-right:0.5em;
      grid-area: b4;
    }
    .entregado-pti{
      grid-area: b5;
    }
    .numero-articulo-sn-l{
      display:flex;
      justify-content: flex-end;
      margin-right:0.5em;
      grid-area: c1;
    }
    .numero-articulo-sn-i{
      grid-area: c2;
    }
    .codigo-almacen-l{
      display:flex;
      justify-content: flex-end;
      margin-right:0.5em;
      grid-area: c4;
    }
    .codigo-almacen-i{
      grid-area: c5;
    }
    .rechazada-l{
      display:flex;
      justify-content: flex-end;
      margin-right:0.5em;
      grid-area: c7;
    }
    .rechazada-i{
      grid-area: c8;
    }
    .descripcion-l{
      display:flex;
      justify-content: flex-end;
      margin-right:0.5em;
      grid-area: d1;
    }
    .descripcion-i{
      grid-area: d2;
      background-color:lightblue; 
    }
    .abierta-l{
      display:flex;
      justify-content: flex-end;
      margin-right:0.5em;
      grid-area: d3;
    }
    .abierta-i{
      grid-area:d4;
    }



  }
  @media screen and (max-width: 576px) {
    .container-detalle { 
      grid-template-columns: repeat(2, 1fr); 
      grid-template-areas: 
        "a1 a1 "
        "a2 a3"
        "b1 b2"
        "b4 b5"
        "c1 c2 "
        "c4 c5" 
        "c7 c8"
        "d1 d2"
        "d3 d4"
      ;
    }

  }

.container-table{
  width: 100%;
  display: grid;
  grid-template-columns: repeat(8,1fr);
  grid-template-areas: 
  "h1 h2 h2 h2 h5 h6 h7 h8"
  "a1 a2 a2 a2 a5 a6 a7 a8"
  ;
  .table-header-articulo{
    display:flex;
    justify-content: center;
    align-items: center; 
    border: 0.5px solid;
    grid-area: h1;
    font-weight: bold;
  }
  .table-header-descripcion{
    display:flex;
    justify-content: center;
    align-items: center; 
    border: 0.5px solid;
    grid-area: h2;
    font-weight: bold;
  }
  .table-header-um{
    display:flex;
    justify-content: center;
    align-items: center; 
    border: 0.5px solid;
    grid-area: h5;
    font-weight: bold;
  }
  .table-header-planificada{
    display:flex;
    justify-content: center;
    align-items: center; 
    border: 0.5px solid;
    grid-area: h6;
    font-weight: bold;
  }
  .table-header-salida{
    display:flex;
    justify-content: center;
    align-items: center; 
    border: 0.5px solid;
    grid-area: h7;
    font-weight: bold;
  }
  .table-header-almacen{
    display:flex;
    justify-content: center;
    align-items: center; 
    border: 0.5px solid;
    grid-area: h8;
    font-weight: bold;
  }
  .table-item-articulo{
    display:flex;
    justify-content: center;
    align-items: center; 
    border: 0.5px solid;
    grid-area: a1;
  }
  .table-item-descripcion{
    display:flex;
    justify-content: center;
    align-items: center; 
    border: 0.5px solid;
    grid-area: a2;
  }
  .table-item-um{
    display:flex;
    justify-content: center;
    align-items: center; 
    border: 0.5px solid;
    grid-area: a5;
  }
  .table-item-planificada{
    display:flex;
    justify-content: center;
    align-items: center; 
    border: 0.5px solid;
    grid-area: a6; 
  }
  .table-item-salida{
    display:flex;
    justify-content: center;
    align-items: center; 
    border: 0.5px solid;
    grid-area: a7;
  }
  .table-item-almacen{
    display:flex;
    justify-content: center;
    align-items: center; 
    border: 0.5px solid;
    grid-area: a8;
  }


}

@media screen and (max-width: 576px) {
    .container-table { 
      grid-template-columns: repeat(7, minmax(80px, 200px)); 
    
      grid-template-areas: 
      "h1 h2 h2 h5 h6 h7 h8"
      "a1 a2 a2 a5 a6 a7 a8"
  ;
    }
    

  }

.container-otros{
  width: 100%;
  display:grid;
 
  grid-template-columns: repeat(8,1fr);
  grid-template-rows: repeat(9, 1fr) ;
  grid-template-areas: 
  "a1 a2 a2 a4 a5 a6 a7 a8"
  "b1 b2 b2 b4 b5 b6 b7 b8"
  "c1 c2 c2 c4 c5 c6 c7 c8"
  "d1 d2 d2 d4 d5 d6 d7 d8"
  "ee1 ee2 e2 ee4 ee5 e6 ee7 ee8"
  "f1 f2 f2 f4 f5 f6 f6 f8"
  "g1 g2 g2 g4 g5 g5 g5 g5"
  "h1 h2 h2 h4 g5 g5 g5 g5"
  "i1 i2 i2 i2 g5 g5 g5 g5" 
  ;
  .tinta1-l{
    display:flex;
    justify-content: flex-end;
    margin-right:0.5em;
    grid-area:a1;
  }
  .tinta1-i{
    grid-area:a2;
  }
  .suaje-l{
    display:flex;
    justify-content: flex-end;
    margin-right:0.5em;
    grid-area:a4;
  }
  .suaje-i{
    grid-area:a5;
  }
  .lote-l{
    display:flex;
    justify-content: flex-end;
    margin-right:0.5em;
    grid-area:a7;
  }
  .lote-i{
    grid-area:a8;
  }
  .tinta2-l{
    display:flex;
    justify-content: flex-end;
    margin-right:0.5em;
    grid-area:b1;
  }
  .tinta2-i{
    grid-area:b2;
  }
  .tinta3-l{
    display:flex;
    justify-content: flex-end;
    margin-right:0.5em;
    grid-area:c1;
  }
  .tinta3-i{
    grid-area:c2;
  }
  .tinta4-l{
    display:flex;
    justify-content: flex-end;
    margin-right:0.5em;
    grid-area:d1;
  }
  .tinta4-i{
    grid-area:d2;
  }
  .tinta5-l{
    display:flex;
    justify-content: flex-end;
    margin-right:0.5em;
    grid-area:ee1;
  }
  .tinta5-i{
    grid-area:ee2;
  }
  .tinta6-l{
    display:flex;
    justify-content: flex-end;
    margin-right:0.5em;
    grid-area:f1;
  }
  .tinta6-i{
    grid-area:f2;
  }
  .reverso-l{
    display:flex;
    justify-content: flex-end;
    margin-right:0.5em;
    grid-area:g1;
  }
  .reverso-i{
    grid-area:g2;
  }
  .barniz-l{
    display:flex;
    justify-content: flex-end;
    margin-right:0.5em;
    grid-area: h1;
  }
  .barniz-i{
    grid-area: h2;
  }
  .procesos-l{
    display:flex;
    justify-content: flex-end;
    margin-right:0.5em;
    grid-area: i1;
  }
  .procesos-i{
    grid-area: i2;
  }
  .planilla-l{
    display:flex;
    justify-content: flex-end;
    margin-right:0.5em;
    grid-area: b4;
  }
  .planilla-i{
    grid-area:b5;
  }
  .corte-l{
    display:flex;
    justify-content: flex-end;
    margin-right:0.5em;
    grid-area:d4;
  }
  .corte-i{
    grid-area:d5;
  }
  .excedente-l{
    display:flex;
    justify-content: flex-end;
    margin-right:0.5em;
    grid-area: ee4;
  }
  .excedente-i{
    grid-area: ee5;
  }
  .pliegos-l{
    display:flex;
    justify-content: flex-end;
    margin-right:0.5em;
    grid-area:f4;
  }
  .pliegos-i{
    grid-area: f5;
  }
  .comentarios-l{
    display:flex;
    justify-content: flex-end;
    margin-right:0.5em;
    grid-area: g4;
  }
  .comentarios-i{
    border: 1px solid;
    grid-area: g5;
  }
  .corrugado-l{
    display:flex;
    justify-content: flex-end;
    margin-right:0.5em;
    grid-area: b7;
  }
  .corrugado-i{
    grid-area: b8;
  }
  .unidadcarga-l{
    display:flex;
    justify-content: flex-end;
    margin-right:0.5em;
    grid-area: c7;
  }
  .unidadcarga-i{
    grid-area: c8;
  }
  .pesoarticulo-l{
    display:flex;
    justify-content: flex-end;
    margin-right:0.5em;
    grid-area: d7;
  }
  .pesoarticulo-i{
    grid-area: d8;
  }
  .peso-corrugado-l{
    display:flex;
    justify-content: flex-end;
    margin-right:0.5em;
    grid-area: ee7;
  }
  .peso-corrugado-i{
    border: 0.5px solid;
    grid-area: ee8;
  }
}
@media screen and (max-width: 576px){
  .container-otros{
    grid-template-columns: repeat(2, 1fr); 
    grid-template-areas: 
    "a1 a2"
    "b1 b2"
    "c1 c2"
    "d1 d2"
    "ee1 ee2"
    "f1 f2"
    "g1 g2"
    "h1 h2"
    "i1 i2"
    "a4 a5"
    "b4 b5"
    "d4 d5"
    "ee4 ee5"
    "f4 f5"
    "a7 a8"
    "b7 b8"
    "c7 c8"
    "d7 d8"
    "ee7 ee8"
    "g4 g5"
    ;
  }
}
.container-cabecera{
  display:flex;
 
  align-items: center; 

  .h2-rciempaques{
    display:inline;
    font-size: 32px;
    text-align: left;
   
  }

  .btn-ofimpresa{
    background-color: #00ac89;
    color: white;
    height: 2em;
    margin-left: 1em;
    padding-top:2%;
    padding-bottom:0;
  }
}
@media screen and (max-width: 576px){
  .container-cabecera{
    flex-direction: column;
    align-content: center;
    margin-bottom:1em;
    
    
  }
}
</style>